import * as React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * THE HELP ROUTE (`/help`) — a thin door, so the page can be code-split.
 *
 * The screen behind it (`help-screen.tsx`: tours, videos, demos, the whole
 * bilingual corpus) is loaded on first visit with `React.lazy`, which keeps it
 * out of the bundle every other screen pays for. This file is what the
 * router imports statically, which is also what the GEN-187 screen census
 * reads: the census enumerates `*-page.tsx` files the router names, and a
 * lazily imported screen would be invisible to it.
 *
 * No permission: like Notifications and Personalization, help belongs to
 * every signed-in account (PART 16.1 rung 4), so the route has no entry in
 * route-permissions.ts and falls through to the session-only floor.
 */
const HelpScreen = React.lazy(() =>
  import('./help-screen').then((module) => ({ default: module.HelpScreen })),
);

export function HelpPage() {
  const { t } = useTranslation();
  return (
    <React.Suspense
      fallback={
        <p role="status" className="py-10 text-center text-sm text-muted-foreground">
          {t('shell.loading')}
        </p>
      }
    >
      <HelpScreen />
    </React.Suspense>
  );
}
